import React, { useState } from "react";
import { SettingContentType } from "../../recoil/settings";
import { useToast } from "../../controller/ToastController";

interface SettingProps {
  mainKey: string;
  subKey: string;
  item: SettingContentType;
  editSetting: (key: string, subKey: string, value: string) => void;
}

const ToggleSetting = ({
  mainKey,
  subKey,
  item,
  editSetting,
}: SettingProps) => {
  return (
    <div className="itemWrap">
      <h2 className="title">
        {item.name === "kioskmode" ? "라운지모드" : item.name}
      </h2>
      <div className="content">
        <div
          className={`toggleWrap  ${item.value === "1" && "active"}`}
          onClick={() =>
            editSetting(mainKey, subKey, item.value === "0" ? "1" : "0")
          }
        >
          <div className={`toggleItem ${item.value === "1" && "active"}`} />
        </div>
      </div>
    </div>
  );
};
export default ToggleSetting;
